export default "__VITE_ASSET__CpoeWr64__"